export default __webpack_public_path__ + "static/media/ian-elder.63152f8d.jpg";